import { render, staticRenderFns } from "./salesGrossBeneathList.vue?vue&type=template&id=bfbd446a"
import script from "./salesGrossBeneathList.vue?vue&type=script&lang=js"
export * from "./salesGrossBeneathList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports